module.exports = __webpack_public_path__ + "static/media/google-pixel-2.23fc0185.jpg";